var ArraySlice = Array.prototype.slice

export default function toArray (obj : {length : number,[key : number] : any}) {
	if (!obj ||  !('length' in obj) ) {
		throw new TypeError('Can not convert the argument to Array')
	}
	try{
		return ArraySlice.call(obj,0)
	}catch(e){
		//fix ie8 bug , eg not support for document.querySelectorAll
		var len = obj.length
		var arr = Array(len)
		for (var i = 0; i < len; i++) {
			arr[i] = obj[i]
		}
		return arr
	}
}